module.exports = __webpack_public_path__ + "static/img/re-record-icon@2x.bcb49c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/toefl/re-record-icon@2x.png
// module id = dM9C
// module chunks = 96